// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__iIa7Q","coverContainer":"styles_coverContainer__1ntEb","cover":"styles_cover__L3Quq"};